enum Events {
  address_created = 'Address Created',
  // Insurance Settings
  automatic_insurance_settings_update = 'Automatic insurance settings update',
  // registered_carrier = 'Registered Carrier',
  carrier_connected = 'Carrier Connected',
  carrier_error_displayed = 'Carrier Error Displayed',
  credit_card_added = 'Credit Card Added',
  customs_items_form_submit = 'Customs Items Form Submit',
  // Customs
  customs_options_form_submit = 'Customs Options Form Submit',
  downgrade_survey_cancelled = 'Pro Plan Downgrade Survey Cancelled',
  downgrade_survey_completed = 'Pro Plan Downgrade Survey Completed',
  // Pro Plan Downgrade Survey events
  downgrade_survey_question_answered = 'Pro Plan Downgrade Survey Question Answered',
  downgrade_survey_submitted = 'Pro Plan Downgrade Survey Submitted',
  // Tracking Settings
  email_notification_changed = 'Email Notifications Changed',
  // Sign-up/Login from Wix
  embeddable_next_params = 'Embeddable User Set Next Params',
  // Get Started
  get_started_viewed = 'Get Started Page View',
  // Cost Clarity Insurance
  insurance_link_clicked = 'Insurance Link Clicked From Sidebar',
  insurance_modal_link_clicked = 'Insurance Modal Link Clicked',
  insurance_modal_opened = 'Insurance Modal Opened',
  // Onboarding
  insurance_option_onboarding = 'Insurance option during onboarding',
  insurance_removal = 'Insurance removal in confirmation modal',
  insurance_removal_order_details = 'Remove Insurance from Order Details',
  // Insurance
  insurance_updated = 'Insurance Updated',
  insurance_upsell_experiment = 'Insurance Upsell Experiment',
  // viewed_rates = 'Viewed Rates',
  label_downloaded = 'Label Downloaded',
  // Label Purchases
  label_purchase = 'Label Purchased',
  label_purchase_failed = 'Label Purchase Failed',
  new_insurance_updated = 'Insurance Updated From Sidebar',
  // Page Not Found events
  not_found_page_viewed = 'Not Found Page Viewed',
  // Order search
  order_search_completed = 'Order search completed',
  order_search_metrics = 'Order Search Metrics',
  order_search_result_selected = 'Order search row selected',

  // Package info edited
  package_info_edited = 'Package Info Updated',
  package_template_created = 'Package Template Created',
  packing_slip_downloaded = 'Packing Slip Downloaded',
  // Pro plan related events
  plan_updated = 'Plan Updated',
  // Billing settings
  promo_code_add_replace = 'Promo code added or replaced',
  recommendation_applied = 'Recommendation Applied',
  recommendation_dismissed = 'Recommendation Dismissed',
  recommendations_dismissed = 'Recommendations Dismissed',

  // Recommendations
  recommended = 'Recommended',
  // General
  registered = 'Signed Up',

  // Package settings
  save_default_package_units = 'Default package units updated',
  /*
   * Emitted as plain strings by the `shipment-alerts` isolated module
   * (`app/isolated/modules/shipment-alerts/`); documentation only — isolated
   * modules cannot import this enum, keep the values in sync with
   * `SHIPMENT_ALERTS_SEGMENT_EVENTS`.
   */
  // Shipment Alerts
  shipment_alerts_claim_submitted = 'Shipment Alerts Claim Submitted',
  shipment_alerts_draft_created = 'Shipment Alerts Draft Created',
  shipment_alerts_exception_dismissed = 'Shipment Alerts Exception Dismissed',
  shipment_alerts_exception_opened = 'Shipment Alerts Exception Opened',
  shipment_alerts_page_viewed = 'Shipment Alerts Page Viewed',
  // Shipment date edited
  shipment_date_updated = 'Shipment Date Updated',
  signature_details_opened = 'Signature Details Opened From Sidebar',

  signature_modal_updated = 'Signature Confirmation Modal Updated',

  signature_removal_order_details = 'Remove Signature from Order Details',

  signature_removed_sidebar = 'Remove Signature From Sidebar',

  signature_updated = 'Signature Details Updated From Sidebar',
  // Signature Settings
  signaure_modal_opened = 'Signature Confirmation Modal Opened',
  store_connected = 'Store Connected',
  store_disconnected = 'Store Disconnected',

  store_initiated = 'Store Connection Initiated',

  tracking_status_viewed = 'Tracking Status Viewed',
  // Profile settings
  update_user_information = 'User profile updated',
  update_user_language = 'User language updated',
  // UPS Surcharge warning
  ups_surcharge_warning = 'UPS surcharge warnings',
}

export const EVENT_ORIGIN_ONBOARDING = 'Onboarding';
export const EVENT_ORIGIN_SIDEPANEL = 'Side panel';
export const EVENT_ORIGIN_ORDER_DETAILS = 'Order details';

export interface Traits {
  blocked_billing?: boolean;
  current_promo_code?: string;
  current_promo_end_date?: string;
  current_promo_start_date?: string;
  date_joined?: string;
  email?: string;
  first_name?: string;
  fraud_status?: string;
  id?: number;
  is_account_owner?: boolean;
  is_idv_required?: boolean;
  last_name?: string;
  lifetime_vol_segment_max?: number;
  lifetime_vol_segment_min?: number;
  login_user_id?: number;
  master_account_available?: boolean;
  orders_count?: number;
  orders_experience?: string; // 'new' | 'classic'
  payment_type?: string;
  personal_carriers?: string[];
  preferred_carrier?: string;
  revenue_tier_name?: string;
  sender_address_city?: string;
  sender_address_company?: string;
  sender_address_country_name?: string;
  sender_address_email?: string;
  sender_address_name?: string;
  sender_address_phone?: string;
  sender_address_state?: string;
  username?: string;
}

// @NOTE: we conditionally send some events to FullStory from the clientside to test funnels
export const FullStoryEventsToBeTracked = [
  Events.label_purchase,
  Events.label_purchase_failed,
  Events.credit_card_added,
  Events.recommended,
  Events.recommendation_applied,
  Events.recommendation_dismissed,
  Events.recommendations_dismissed,
  Events.store_initiated,
];

export default Events;
